import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<{ peaRiskAllocationLevel: number }> = {
      peaRiskAllocationLevel: [
        parameters?.peaRiskAllocationLevel || 4,
        [Validators.required, Validators.min(1), Validators.max(7)],
      ],
    };

    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return { ...this.form.value };
  }
}
